<template src="./index.html"></template>
<script>
import {
  jxzc_updateLy_api,
  jxzc_jxzcInfoPage_api,
  jxzc_initJxzcInfo_api,
  jxzc_updateIinvoutData_api,
  jxzc_clearNowTax_api,
  jxzc_dataOriginInfoPage_api,
  jxzc_chakywbm_api,
  jxzc_login_api,
} from "../../../../api/iinvout.js";
import {getdata} from "./data.js";
import mxdj from "./mxdj/index.vue";
import hzck from "./hzck/index.vue";
import config from "../../../../../configHttp";
export default {
  name: "jxzc",
  components: {
    mxdj,
    hzck,
  },
  data: function () {
    return {
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      searchdiag: false,
      outlist: [],
      headData: getdata().headData,
      shaidiag: false,
      tableData: getdata().tableData,
      pagination: getdata().pagination,
      lypagination: getdata().lypagination,
      sort: "",
      order: "",
      disck: true,
      sjlydiag: false,
      headlyData: getdata().headlyData,
      tablelyData: getdata().tablelyData,
      headckywData: getdata().headckywData,
      tableckywData: getdata().tableckywData,
      showmxdj: false,
      showhzck: false,
      ckywbmdiag: false,
      suosq: this.$getdefultMonth(),
      hzckInitData: getdata().hzckInitData, //汇总查看页面数据传输
      mxdjInitData: getdata().mxdjInitData, //明细登记页面数据传输
	  tablekey:0,
	  overlength:0
    };
  },
  created() {
    // let loginParam = {
    //   password: "123456",
    //   username: "admin",
    // };
    // jxzc_login_api(loginParam).then((res) => {
      // todo 登录功能写完之后，这一块要去掉
      // if (res.data.code == 1) {
      //   localStorage.setItem("nstoken", res.data.data);
      // } else {
      //   this.$message.error(res.data.msg);
      // }
    // }); //
  },
  mounted() {
        this.init();
    
  },
  methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
    closehzck() {
      this.showhzck = false;
    },
    closesgdj() {
      this.getJxzcInfo();
      this.showmxdj = false;
    },
    sjlypz() {
      this.getDataOriginInfo();
    },
    submitSearch(data) {
      this.getJxzcInfo();
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.getJxzcInfo();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.getJxzcInfo();
    },
    sizechangely(e) {
      this.lypagination.pageSize = e;
      this.getDataOriginInfo();
    },
    currentChangely(e) {
      this.lypagination.pageNum = e;
      this.getDataOriginInfo();
    },
    formxdj(row) {
      if (!row.sfyshenbao) {
        return;
      }
      this.mxdjInitData.nsrsbh = row.nsrsbh;
      this.mxdjInitData.suosq = row.suosq;
      this.mxdjInitData.outId = row.id;
      this.showmxdj = true;
    },
    forhzck(row) {
      if (!row.sfydata) {
        return;
      }
      this.hzckInitData.nsrsbh = row.nsrsbh;
      this.hzckInitData.suosq = row.suosq;
      this.showhzck = true;
    },
    //批量更新取数 到时候可能做异步处理，所以和单个更新取数区分开来
    updateBatchData() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      if (selectVal.length == 0) {
        this.$message.info("请选中数据再进行更新取数操作");
        return;
      }
      let suosq = selectVal[0].suosq;
      let ids = new Array(selectVal.length);
      try {
        selectVal.forEach((v, k) => {
          if (v.shujly != 1) {
            throw new Error("只有数据来源为‘科目余额表’才能进行更新取数操作");
          }
          if (suosq != v.suosq) {
            throw new Error("只有相同所属期期才能进行批量更新取数");
          }
          ids[k] = v.id;
        });
      } catch (e) {
        this.$message.info(e.message);
        return;
      }
      this.updateJinxzData(ids, suosq);
    },
    //单条数据更新取数
    updateSingleData(row) {
      if (!row.sfyshenbao) {
        return;
      }
      if (row.shujly != 1) {
        this.$message.info("只有数据来源为‘科目余额表’才能进行更新取数操作");
        return;
      }
      let ids = [row.id];
      this.updateJinxzData(ids, row.suosq);
    },
    //更新取数
    updateJinxzData(e, ssq) {
      let param = {
        ids: e,
        suosq: ssq,
      };
      jxzc_updateIinvoutData_api(param).then((res) => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.getJxzcInfo();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //初始化数据
    init() {
       jxzc_initJxzcInfo_api({}).then((res) => {
        if (res.data.code != 1) {
          this.$message.error(res.data.msg);
        } else {
          this.suosq = res.data.data.suosq; //获取当前所属期yyyymm
          this.searchdata.suosq = this.$getdefultMonth()
          this.getJxzcInfo();
        }
      });
    },
    //查询
    getJxzcInfo() {
      if (this.suosq == null || this.suosq === undefined) {
        this.$message.info("请选择所属期");
        return;
      }
      //查询数据
      let params = params = this.searchdata;
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = "id";
      jxzc_jxzcInfoPage_api(params).then((res) => {
        if (res.data.code == 1) {
          this.pagination.total = res.data.data.total;
          this.pagination.paginationkey++;
          this.tableData = res.data.data.records;
          this.jinyongpd();
        } else {
          this.$message.error(res.data.msg);
          return;
        }
      });
    },
    //按钮禁用判断
    jinyongpd() {
      this.tableData.forEach((res) => {
        res.sfydata = res.zhuancse ? true : false; //是否有转出数据
        res.sfyshenbao = res.suosqbz == "1" ? true : false; //是否是当前申报期
      });
    },
    getDataOriginInfo() {
      //查询数据
      let params = {};
      params.current = this.lypagination.pageNum;
      params.size = this.lypagination.pageSize;
      params.suosq = this.searchdata.suosq;
      jxzc_dataOriginInfoPage_api(params).then((res) => {
        if (res.data.code != 1) {
          this.$message.error(res.data.msg);
        } else {
          this.lypagination.total = res.data.data.total;
          this.lypagination.paginationkey++;
          this.tablelyData = res.data.data.records;
          this.tablelyData.forEach((item) => {
            item.radiolist = this.$ShujlyMapping;
          });
        }
        this.sjlydiag = true;
      });
    },
    //清空数据
    clearData(row) {
      if (!row.sfydata || !row.sfyshenbao) {
        return;
      }
      this.$showConfirm({
        message: "清空数据后当前税款所属期间内的所有数据将清除，是否确认操作？",
      }).then((res) => {
        if (res == "confirm") {
          this.clearNowTax(row);
        }
      });
    },
    clearNowTax(e) {
      let param = {
        id: e.id,
        suosq: e.suosq,
      };
      jxzc_clearNowTax_api(param).then((res) => {
        if (res.data.code == 1) {
          this.$message.success("清空数据成功");
          this.getJxzcInfo();
        } else {
            this.$message.error(res.data.msg);
        }
      });
    },
    //置为手工开票/置为科目余额表
    changeBatchShujlyButton(val) {
      let selectVal = this.$refs.tableboxly.getSelectionval();
      if (selectVal.length < 1) {
        this.$message.info("请选择数据再进行操作");
        return;
      }
      selectVal.forEach((item) => {
        item.laiy = val;
      });
    },
    //数据来源配置返回按钮
    closeDataOriginConfigButton() {
      this.sjlydiag = false;
    },
    //数据来源配置保存按钮
    saveDataOriginConfigButton() {
      this.$showConfirm({
        message:
          "切换数据来源，会清空当前纳税人下未申报成功的税款所属期已有数据（已申报成功的数据不受影响），是否继续？",
      }).then((res) => {
        if (res == "confirm") {
          this.saveDataOriginConfig();
        }
      });
    },
    //保存数据来源配置
    saveDataOriginConfig() {
      let param = this.tablelyData;
      jxzc_updateLy_api(param).then((res) => {
        if (res.data.code == 1) {
          this.$message.success("保存成功");
        } else {
          this.$message.error(res.data.msg);
        }
        this.getJxzcInfo();
        this.sjlydiag = false;
      });
    },
    //保存数据来源配置
    chakywbm() {
      jxzc_chakywbm_api({}).then((res) => {
        if (res.data.code == 1) {
          this.tableckywData = res.data.data;
          this.ckywbmdiag = true;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //导出列表
    downloadJxzc() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      let params = {
        jinxzcExtendSearchInputDTO: {},
      };
      if (selectVal.length < 1) {
        params.jinxzcExtendSearchInputDTO = this.searchdata;
        params.jinxzcExtendSearchInputDTO.order = "asc";
        params.jinxzcExtendSearchInputDTO.sort = "id";
        params.jinxzcExtendSearchInputDTO.current = this.pagination.pageNum;
        params.jinxzcExtendSearchInputDTO.size = this.pagination.pageSize;
      } else {
        let _ids = selectVal.map((item) => item.id);
        params.ids = _ids;
      }
      params.json = getdata().tableJson;
      this.fileDownload(params);
    },
    fileDownload(val) {
      //jxzc_download_api(val);
      let params = {
        downUrl: config.baseURL + "/iinvout/list/export",
        typeObj: {
          toForm: false,
          fileType: "xlsx",
          fileName: "进项转出数据"+ this.$timestampToStr(new Date(), "yyyyMMdd"),
          failUrl:this.$winURl
        },
        params: val,
      };
      this.$downloadcommon(params);
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
